import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components';
import classNames from 'classnames';

import css from './CookieConsent.module.css';

class CookieConsent extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      show: false,
      cookiebotLoaded: false 
    };
    this.onAcceptCookies = this.onAcceptCookies.bind(this);
    this.saveCookieConsent = this.saveCookieConsent.bind(this);
    this.loadCookiebotScript = this.loadCookiebotScript.bind(this);
    this.cookiebotContainerRef = React.createRef();
  }

  componentDidMount() {
    const cookies = document.cookie.split('; ').reduce((acc, c) => {
      const [name, value] = c.split('=');
      return { ...acc, [name]: decodeURIComponent(value) };
    }, {});

    if (cookies.euCookiesAccepted !== '1') {
      this.setState({ show: true });
    }
    
    // Load Cookiebot script
    this.loadCookiebotScript();
  }

  loadCookiebotScript() {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      return;
    }

    // Create the script element
    const cookiebotScript = document.createElement('script');
    cookiebotScript.id = 'CookieDeclaration';
    cookiebotScript.src = 'https://consent.cookiebot.com/842ef83c-cce8-489c-a1f4-38ed3f5017b1/cd.js';
    cookiebotScript.type = 'text/javascript';
    cookiebotScript.async = true;
    
    // Add event listener to know when the script is loaded
    cookiebotScript.addEventListener('load', () => {
      this.setState({ cookiebotLoaded: true });
    });
    
    // Add the script to the cookiebot container if it exists, otherwise to document.body
    if (this.cookiebotContainerRef.current) {
      this.cookiebotContainerRef.current.appendChild(cookiebotScript);
    } else {
      document.body.appendChild(cookiebotScript);
    }
  }

  onAcceptCookies() {
    this.saveCookieConsent();
    this.setState({ show: false });
    
    // If Cookiebot exists, trigger it to accept all cookies
    if (window.Cookiebot && typeof window.Cookiebot.submitCustomConsent === 'function') {
      window.Cookiebot.submitCustomConsent(true, true, true);
    }
  }

  saveCookieConsent() {
    // We create date object and modify it to show date 10 years into the future.
    let expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 10);
    // Save the cookie with expiration date
    document.cookie = 'euCookiesAccepted=1; path=/; expires=' + expirationDate.toGMTString();
  }

  render() {
    const { className, rootClassName } = this.props;
    const isServer = typeof window === 'undefined';

    // Server side doesn't know about cookie consent
    if (isServer || !this.state.show) {
      // Even if we don't show the banner, we still want to render the cookiebot container
      return (
        <div 
          ref={this.cookiebotContainerRef} 
          id="CookieDeclarationContainer" 
          className={css.cookieDeclarationContainer}
        />
      );
    } else {
      const cookieLink = (
        <ExternalLink href="https://www.websitepolicies.com/policies/view/464geoa8" className={css.cookieLink}>
          <FormattedMessage id="CookieConsent.cookieLink" />
        </ExternalLink>
      );
      const classes = classNames(rootClassName || css.root, className);

      return (
        <>
          <div className={classes}>
            <div className={css.message}>
              <FormattedMessage id="CookieConsent.message" values={{ cookieLink }} />
            </div>
            <button className={css.continueBtn} onClick={this.onAcceptCookies}>
              <FormattedMessage id="CookieConsent.continue" />
            </button>
          </div>
          <div 
            ref={this.cookiebotContainerRef} 
            id="CookieDeclarationContainer" 
            className={css.cookieDeclarationContainer}
          />
        </>
      );
    }
  }
}

const { string } = PropTypes;

CookieConsent.defaultProps = {
  className: null,
  rootClassName: null,
};

CookieConsent.propTypes = {
  className: string,
  rootClassName: string,
};

export default CookieConsent;
